import { Component, effect, inject, OnInit, ViewChild } from '@angular/core';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { TranslateService } from '@ngx-translate/core';
import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { Router } from '@angular/router';
import { createServerQuery } from '@/components/data-table-builder/server-query';
import { getDynamicDocumentsDataTableStructure } from './utils/dynamic-form.datatable';
import { DynamicFormsService } from './dynamic-forms.service';
import { MessageService } from 'primeng/api';
import { DynamicForm } from '@/types';
import { DialogComponent } from '@/components/dialog/dialog.component';
import { DialogObject } from '@/components/dialog/dialog.types';
import { getDynamicFormDeleteObject } from './utils/dynamic-form.delete-dialog-object';
import { DynamicFormRepository } from '@/store/dynamic-form-state/dynamic-form.repository';
@Component({
  selector: 'sm-dynamic-forms',
  imports: [PageHeaderComponent, DataTableBuilderComponent, DialogComponent],
  templateUrl: './dynamic-forms.component.html',
  styleUrl: './dynamic-forms.component.scss',
})
export class DynamicFormsComponent implements OnInit {
  dynamicFormRepository = inject(DynamicFormRepository);
  dynamicFormsService = inject(DynamicFormsService);
  router = inject(Router);
  translate = inject(TranslateService);
  messageService = inject(MessageService);

  breadcrumb = [
    {
      label: 'transanctionalForm.title',
      routerLink: ['/settings', 'dynamic-forms'],
    },
  ];

  @ViewChild('dialog') dialogComponent!: DialogComponent;
  dynamicFormDialog?: DialogObject;

  loading = false;
  title: string = this.translate.instant('transanctionalForm.title');

  rowActions: DataTableRowActions = {
    defaultActions: {
      inspect: {
        label: 'Inspecter',
      },
      edit: {
        label: 'Modifier',
      },
      delete: {
        label: 'Supprimer',
      },
    },
    inspectAction: doc => {
      this.router.navigate(['settings', 'dynamic-forms-inspect', doc.id]);
    },
    editAction: doc => {
      this.router.navigate(['settings', 'dynamic-forms-edit', doc.id]);
    },
    deleteAction: row => {
      this.dynamicFormDialog = getDynamicFormDeleteObject({
        store: this.dynamicFormRepository,
        representation: row.name,
        action: () => {
          this.deleteDynamicForm(row.id);
          this.dialogComponent.toggleVisible();
        },
        toggleVisiblity: () => this.dialogComponent.toggleVisible(),
      });
      this.dialogComponent.toggleVisible();
    },
  };

  data: DynamicForm[] = [];
  totalRecords = 0;
  serverQuery = createServerQuery({});
  datatableObject: DynamicDataTable = getDynamicDocumentsDataTableStructure({
    rowActions: this.rowActions,
    createAction: () => {
      this.router.navigate(['/settings/dynamic-forms/new']);
    },
    serverQuery: this.serverQuery,
  });

  constructor() {
    effect(() => {
      this.loadData();
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.dynamicFormsService
      .getPaginatedDynamicForms({
        page: this.serverQuery.page(),
        size: this.serverQuery.pageSize(),
        search: this.serverQuery.search(),
        sort: this.serverQuery.sortBy() ? `${this.serverQuery.sortBy()},${this.serverQuery.sortOrder()}` : '',
      })
      .subscribe({
        next: data => {
          this.data = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        },
        error: error => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error.message,
          });
        },
      });
  }

  deleteDynamicForm(id: number) {
    return this.dynamicFormsService.deleteDynamicForm(id).subscribe({
      next: () => {
        this.loadData();
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'Le formulaire dynamique a été supprimé avec succès',
        });
      },
      error: error => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: error.error.message,
        });
      },
    });
  }
}
